export default from './breadcrumbs';



// WEBPACK FOOTER //
// ./app/components/breadcrumbs/index.js